import type { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
	// biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="8"
		height="8"
		fill="none"
		viewBox="0 0 8 8"
		{...props}
	>
		<path
			stroke="var(--svg-color, currentColor)"
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M.855 3.765 3.31 6.221l3.795-3.795"
		/>
	</svg>
);

export { SvgComponent as Checkmark };
